import { useEffect } from "react";
import { logClick } from "../debug/uiLog";

/**
 * Capture all clicks on interactive elements for trace logging.
 * Runs after React mounts to ensure all elements are in the DOM.
 */
export function useClickCapture(): void {
  useEffect(() => {
    const handleClick = (e: Event) => {
      const el = e.target as HTMLElement;
      const interactive = el.closest(
        "button, [role='button'], a, label, [data-testid]",
      ) as HTMLElement | null;
      if (!interactive) return;
      const label =
        interactive.getAttribute("data-testid") ||
        interactive.getAttribute("aria-label") ||
        interactive.textContent?.trim().replace(/\s+/g, " ").slice(0, 80) ||
        "unknown";
      logClick(label);
    };

    // Attach to root element in capture phase
    const root = document.getElementById("root");
    if (root) {
      root.addEventListener("click", handleClick, true);
      return () => root.removeEventListener("click", handleClick, true);
    }
  }, []);
}
